<template>
    <div class="order-list__search">
        <div class="order-list__search-input">
            <input type="text" placeholder="Поиск">
        </div>
        <div class="order-list__sort">
            <div class="order-list__found">
                <span>Найдено</span>
                <span>45</span>
            </div>
            <div class="order-list__show">
                <span>Показывать по</span>
                <div class="order-list__select" @click="openSearchDropdown($event)">
                    <span>15</span>
                    <div class="order-list__select-box">
                        <span @click="searchDropdownChoice($event)">15</span>
                        <span @click="searchDropdownChoice($event)">30</span>
                        <span @click="searchDropdownChoice($event)">45</span>
                    </div>
                </div>
            </div>
            <div class="order-list__find-page tablet">
                <span>Перейти к</span>
                <div class="order-list__select" @click="openSearchDropdown($event)">
                    <span>1</span>
                    <div class="order-list__select-box">
                        <span @click="searchDropdownChoice($event)">1</span>
                        <span @click="searchDropdownChoice($event)">2</span>
                        <span @click="searchDropdownChoice($event)">3</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-list__pages">
            <div class="order-list__find-page">
                <span>Перейти к</span>
                <div class="order-list__select" @click="openSearchDropdown($event)">
                    <span>1</span>
                    <div class="order-list__select-box">
                        <span @click="searchDropdownChoice($event)">1</span>
                        <span @click="searchDropdownChoice($event)">2</span>
                        <span @click="searchDropdownChoice($event)">3</span>
                    </div>
                </div>
            </div>
            <div class="order-list__pagination">
                <button-component class="order-list__pagination-button active" button-text="1"/>
                <button-component class="order-list__pagination-button" button-text="2"/>
                <button-component class="order-list__pagination-button" button-text="3"/>
                <button-component class="order-list__pagination-button" button-text="4"/>
                <button-component class="order-list__pagination-button" button-text="5"/>
                <button-component class="order-list__pagination-button" button-text="..." :disabled="true"/>
                <button-component class="order-list__pagination-button" button-text="30"/>
                <button-component class="order-list__pagination-button" button-text="Дальше"/>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import buttonComponent from '../shared/buttonComponent.vue'

function openSearchDropdown(event: Event) {
    let element = event.target as HTMLElement
    if (element?.classList[0] === 'order-list__select') {
        element.classList.toggle('active')
    }
    else if (element?.parentElement?.classList[0] === 'order-list__select') {
        element.parentElement.classList.toggle('active')
    }
}

function searchDropdownChoice(event: Event) {
    let element = event.target as HTMLElement
    let target = element.closest('.order-list__select') as HTMLElement
    if (target.children[0]) {
        (target.children[0] as HTMLElement).innerText = element?.innerText
    }
    if (target) {
        target.classList.remove('active')
    }
}
</script>